<div class="nb-theme-default">
<!-- <nb-card>
    <nb-card-body> -->
        <!-- <div *ngIf="mode === 'range'; else dateMode"> -->
            <input nbInput placeholder="Pick Date Range" [nbDatepicker]="formpi">
            <nb-rangepicker #formpi></nb-rangepicker>
        <!-- </div>
        <ng-template #dateMode>
            <input nbInput placeholder="Pick Date" [nbDatepicker]="formpick">
            <nb-datepicker #formpick></nb-datepicker>
        </ng-template> -->
    <!-- </nb-card-body>
</nb-card> -->

</div>